module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "action"
  }, [_c('div', {
    class: ['box', {
      'active': _vm.currPath === '/contact'
    }],
    on: {
      "click": function($event) {
        return _vm.topage('contact')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/contact@2x.png",
      "alt": ""
    }
  }), _vm._v("联系我们\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": _vm.onLogin
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/login@2x.png",
      "alt": ""
    }
  }), _vm._v("登录注册\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/logo_white.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.topage('/')
      }
    }
  }), _vm._v(" "), _c('div', {
    class: ['nav-item', {
      'active': _vm.caseList.includes(_vm.currPath)
    }]
  }, [_vm._v("我们的方案\n        "), _c('div', {
    staticClass: "nav-list"
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.topage('/core')
      }
    }
  }, [_vm._v("核心企业")]), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        return _vm.topage('/institution')
      }
    }
  }, [_vm._v("金融机构")]), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        return _vm.topage('/chain')
      }
    }
  }, [_vm._v("供应商 / 经销商")])])]), _vm._v(" "), _c('div', {
    class: ['nav-item', {
      'active': _vm.advantageList.includes(_vm.currPath)
    }]
  }, [_vm._v("我们的优势\n        "), _c('div', {
    staticClass: "nav-list"
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.topage('product')
      }
    }
  }, [_vm._v("平台产品")]), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        return _vm.topage('service')
      }
    }
  }, [_vm._v("供应链金融服务")])])]), _vm._v(" "), _c('div', {
    class: ['nav-item', {
      'active': _vm.aboutList.includes(_vm.currPath)
    }]
  }, [_vm._v("关于群星\n        "), _c('div', {
    staticClass: "nav-list"
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.topage('about')
      }
    }
  }, [_vm._v("公司介绍")]), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        return _vm.topage('news')
      }
    }
  }, [_vm._v("群星资讯")]), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        return _vm.topage('join')
      }
    }
  }, [_vm._v("加入群星")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-0419f059"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/components/Header.vue
// module id = 1248
// module chunks = 26